import React from 'react'
import ModalFormUI from './ModalFormUI'
import InputTextSF from './InputTextSF'
import InputFieldUI from './InputFieldUI'

const FileUploadWithFileNameModalUI = ({ context, fileInput, multiple,
  uploadMode, handleSubmit, submitted, onCancelClick, titleLabel,
  successMsg, errorList, setErrorList,
  othersFileName, onOthersFileNameChange, othersFileNameError, setOthersFileNameError, hint
}) =>
  <ModalFormUI
    context={context}
    titleLabel={titleLabel || 'Upload file'}
    buttonLabel='Upload'
    cancelLabel='Cancel'
    isOpen={uploadMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={handleSubmit}
    busy={submitted}
  >
    <InputTextSF type='text' label='File name' required={true}
      value={othersFileName} onChange={onOthersFileNameChange}
      error={othersFileNameError} setError={setOthersFileNameError}
      help={hint}
    />
    <InputFieldUI>
      <input type='file' ref={fileInput} />
    </InputFieldUI>

  </ModalFormUI>

export default FileUploadWithFileNameModalUI
